import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=07c2d446&scoped=true&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=07c2d446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2d446",
  null
  
)

export default component.exports